import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/awards/client/AwardsTimelineClient.tsx");
